export default {
  "name": "Canva Template",
  "assets": [
    {
      "id": "youtube_thumbnail",
      "name": "YouTube Thumbnail (1280x720)",
      "width": 1280,
      "height": 720,
      "category": "Social Media",
      "backgroundColor": "#ffffff",
      "preview": "templates/youtube_thumbnail.png",
      "description": "Standard 16:9 thumbnail per video YouTube ad alta risoluzione."
    },
    {
      "id": "instagram_post",
      "name": "Instagram Post Quadrato (1080x1080)",
      "width": 1080,
      "height": 1080,
      "category": "Social Media",
      "backgroundColor": "#ffffff",
      "preview": "templates/instagram_post.png",
      "description": "Formato 1:1 ottimizzato per post feed Instagram e Facebook."
    },
    {
      "id": "instagram_story_tiktok",
      "name": "Story / TikTok / Reel (1080x1920)",
      "width": 1080,
      "height": 1920,
      "category": "Social Media",
      "backgroundColor": "#ffffff",
      "preview": "templates/instagram_story.png",
      "description": "Formato verticale 9:16 per Stories, TikTok, YouTube Shorts e Reels."
    },
    {
      "id": "facebook_cover",
      "name": "Facebook Cover / Banner (1640x924)",
      "width": 1640,
      "height": 924,
      "category": "Banner",
      "backgroundColor": "#ffffff",
      "preview": "templates/facebook_cover.png",
      "description": "Copertina per pagine e gruppi Facebook con area sicura per desktop e mobile."
    },
    {
      "id": "twitter_header",
      "name": "Twitter / X Header (1500x500)",
      "width": 1500,
      "height": 500,
      "category": "Banner",
      "backgroundColor": "#ffffff",
      "preview": "templates/twitter_header.png",
      "description": "Banner orizzontale 3:1 per profilo Twitter / X."
    },
    {
      "id": "presentation_16_9",
      "name": "Presentazione HD (1920x1080)",
      "width": 1920,
      "height": 1080,
      "category": "Presentazioni",
      "backgroundColor": "#ffffff",
      "preview": "templates/presentation.png",
      "description": "Slide Full HD per presentazioni, pitch deck e proiezioni."
    },
    {
      "id": "a4_document",
      "name": "Documento A4 Stampa (1240x1754)",
      "width": 1240,
      "height": 1754,
      "category": "Documenti",
      "backgroundColor": "#ffffff",
      "preview": "templates/a4_document.png",
      "description": "Foglio standard A4 in verticale per volantini, poster o documenti."
    },
    {
      "id": "game_landscape",
      "name": "Gioco / Animazione 2D (960x540)",
      "width": 960,
      "height": 540,
      "category": "Gaming & Animazione",
      "backgroundColor": "#ffffff",
      "preview": "templates/game_landscape.png",
      "description": "Risoluzione ottimale e leggera per animazioni web e giochi interattivi."
    }
  ]
}
